import { AsymmetryDetails } from '../analysis/asymentry-details.models';
import { AnalysisAnnotations } from '../analysis/analysis-annotations.model';
import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';
import { CombinedLongeingStatusEnum } from '../enums/combined-longeing.enum';
import { CombinedLongeingStatus } from '../types/combined-longeing.type';

export interface CombinedLongeingRecordings {
  left: string | null;
  right: string | null;
}

export class CombinedLongeingRecordingsClass implements CombinedLongeingRecordings {
  left: string | null;
  right: string | null;

  constructor(o: any = {}) {
    this.left = o['left'] ?? null;
    this.right = o['right'] ?? null;
  }
}

export interface CombinedLongeingData {
  combinedId: string;
  horseId: string;
  computationVersion?: string;
  areComparable?: boolean;
  creationDate: Date | null;
  recordings: CombinedLongeingRecordings;
  analysisDetails?: AsymmetryDetails | null;
  analysisAnnotations?: AnalysisAnnotations | null;
  status: CombinedLongeingStatus;
}

export class CombinedLongeingDataClass implements CombinedLongeingData {
  combinedId: string;
  horseId: string;
  computationVersion?: string;
  areComparable?: boolean;
  creationDate: Date | null;
  recordings: CombinedLongeingRecordings;
  analysisDetails?: AsymmetryDetails | null;
  analysisAnnotations?: AnalysisAnnotations | null;
  status: CombinedLongeingStatus;

  constructor(o: any = {}) {
    this.combinedId = o['combinedId'] ?? o['id'] ?? '';
    this.horseId = o['horseId'] ?? '';
    this.computationVersion = o['computationVersion'] ?? undefined;
    this.areComparable =
      o['areComparable'] !== undefined && o['areComparable'] !== null
        ? Boolean(o['areComparable'])
        : undefined;
    this.creationDate = extractDateTimeStamp(o['creationDate']);
    this.recordings = new CombinedLongeingRecordingsClass(o['recordings'] ?? {});
    this.analysisDetails = o['analysisDetails'] ?? null;
    this.analysisAnnotations = o['analysisAnnotations'] ?? null;
    this.status = o['status'] ?? CombinedLongeingStatusEnum.SUBMITTED;
  }
}
